import React, { useRef } from 'react'
import { cancelToken, post, postXlsx } from '@fareye/utils'
import { DEVICE_CONFIG } from '../../../config/constants'
import { Button, styled, toast } from '@fareye/ui'
const FileInput = styled.input`
  display: none;
`
const FileUpload = ({ setReloadDevice }: any) => {
  const source = cancelToken().source()
  const ref = useRef<any>(null)
  const handleFileUpload = async (event: any) => {
    const file = event.target.files[0]
    try {
      const url = `${DEVICE_CONFIG.deviceUpload}`
      // get the selected file from the input
      console.log(file, '*******', event)
      // create a new FormData object and append the file to it
      const formData = new FormData()
      formData.append('file', file)
      // make a POST request to the File Upload API with the FormData object and Rapid API headers
      const { data } = await post(url, formData, source.token, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (data.success) {
        toast.success(data.message)
      }
      ref.current.value = null
      setReloadDevice((count: any) => count + 1)
    } catch (e:any) {
      const message = e?.response?.data?.message
      if (message) {
        toast.error(message)
      } else {
        console.error(e)
      }
      ref.current.value = null
    }
  }
  const handleClick = () => {
    ref?.current?.click()
  }
  // render a simple input element with an onChange event listener that calls the handleFileUpload function
  return (
    <>
      <FileInput ref={ref} type="file" onChange={handleFileUpload} />
      <Button variant="primary" onClick={handleClick}>
        Import Devices
      </Button>
    </>
  )
}
export default FileUpload
